export default __webpack_public_path__ + "static/media/img-slider-urban-transit-6.a2dc31ef.png";